import axios from "axios";
export default {
  chkStr(str) {
    let temp = null;
    if (str === undefined) {
      temp = null;
    } else if (str !== null && str.trim() === "") {
      temp = null;
    } else {
      temp = str;
    }
    return temp;
  },
  /* 숫자형 체크 함수 defVal : default Value */
  chkNum(num, defVal) {
    let temp = null;
    if (num === undefined || num === null) {
      temp = defVal !== undefined ? defVal : null;
    } else if (num !== null) {
      if (typeof num === "string" && num.trim() === "") {
        temp = defVal !== undefined ? defVal : null;
      } else {
        temp = num;
      }
    }
    return temp;
  },
  chkNull(val, instdVal) {
    let temp = null;
    if (val === undefined || val === null) {
      if (instdVal === undefined) temp = null;
      else temp = instdVal;
    } else {
      temp = val;
    }
    return temp;
  },
  lpad(str, lng, arg) {
    if (arg.length !== 1) return null;
    if (typeof str !== "string") return null;
    var tmp = str;
    for (let i = str.length; i < lng; i++) {
      tmp = arg + tmp;
    }
    return tmp;
  },
  getExcelCol(gridOpts) {
    var excelColOrder = [];
    var cols = gridOpts.columnApi.getAllGridColumns();
    for (let i = 0; i < cols.length; i++) {
      let colYn = !cols[i].visible;
      if (colYn === undefined || colYn === false) {
        let selectParam = cols[i].colDef.cellRendererParams;
        if (selectParam === undefined) {
          selectParam = null;
        } else {
          if (selectParam.values !== undefined) {
            let j = 0;
            for (j = 0; j < selectParam.values.length; j++) {
              if (selectParam.values[j].value === "-") break;
            }
            if (j !== selectParam.values.length) {
              selectParam = null;
            }
          } else {
            selectParam = null;
          }
        }
        excelColOrder.push({
          field: cols[i].colDef.field,
          headNm: cols[i].colDef.headerName,
          cellWidth: cols[i].actualWidth,
          cellAlign:
            cols[i].colDef.cellStyle === undefined ||
            cols[i].colDef.cellStyle.textAlign === undefined
              ? "center"
              : cols[i].colDef.cellStyle.textAlign,
          cellSelectParam: selectParam === null ? null : selectParam.values,
        });
      }
    }
    return excelColOrder;
  },
  getExcelColAll(gridOpts) {
    var excelColOrder = [];
    var cols = gridOpts.columnApi.getAllGridColumns();
    for (let i = 0; i < cols.length; i++) {
      let selectParam = cols[i].colDef.cellRendererParams;
      if (selectParam === undefined) {
        selectParam = null;
      } else {
        let j = 0;
        for (j = 0; j < selectParam.values.length; j++) {
          if (selectParam.values[j].value === "-") break;
        }
        if (j !== selectParam.values.length) {
          selectParam = null;
        }
      }
      excelColOrder.push({
        field: cols[i].colDef.field,
        headNm: cols[i].colDef.headerName,
        cellWidth: cols[i].actualWidth,
        cellAlign:
          cols[i].colDef.cellStyle === undefined ||
          cols[i].colDef.cellStyle.textAlign === undefined
            ? "center"
            : cols[i].colDef.cellStyle.textAlign,
        cellSelectParam: selectParam === null ? null : selectParam.values,
      });
    }
    return excelColOrder;
  },
  // getExcelFile(응답, 이벤트, 파일 이름)
  getExcelFile(res, fileName, extension) {
    console.log("extension", extension);
    let blob = new Blob([res.data], { type: res.headers["content-type"] });
    // 기본 파일이름 : export_yyyymmdd.xlsx
    fileName += extension ? "." + extension : ".xlsx";
    let tempTag = document.createElement("a");
    tempTag.id = "excelDown";
    tempTag.href = window.URL.createObjectURL(blob);
    tempTag.target = "_self";
    tempTag.style.display = "none";
    tempTag.download = fileName;
    tempTag.click();
    tempTag.remove();
  },
  // getExcelFile(res, parEl, fileName, extension) {
  //   let blob = new Blob([res.data], { type: res.headers["content-type"] });
  //   // 기본 파일이름 : export_yyyymmdd.xlsx
  //   fileName += extension ? "." + extension : ".xlsx";
  //   let tempTag = document.createElement("a");
  //   tempTag.id = "excelDown";
  //   tempTag.href = window.URL.createObjectURL(blob);
  //   tempTag.target = "_self";
  //   tempTag.style.display = "none";
  //   parEl.insertBefore(tempTag, parEl.childNodes[0]);
  //   tempTag.download = fileName;
  //   tempTag.click();
  //   tempTag.remove();
  // },
  /*
    함수명 : excelDownload
    파라미터 : 요청 파라미터(param), 그리드 옵션(gridOpts),
    다운로드 Url(downUrl), 버튼 상위 El(parEl), 파일명(fileName)
  */
  async excelDownload(param, gridOpts, downUrl, parEl, fileName) {
    var req = param;
    req.excelCol = null;
    req.dataList = [];
    req.excelCol = this.getExcelCol(gridOpts);
    gridOpts.api.forEachNode(function (node, idx) {
      req.dataList.push(node.data);
    });
    try {
      const res = await axios.post(downUrl, req, {
        responseType: "arraybuffer",
        timeout: 20 * 60 * 1000,
      });
      this.getExcelFile(res, fileName);
      return true;
    } catch (err) {
      console.error(err);
      if (err.message.includes("timeout")) {
        alert("TIMEOUT");
      }
    }
  },
  /* excelDownload(param, gridOpts, downUrl, parEl, fileName) {
    var req = {
      input: param,
      excelCol: null,
      dataList: [],
    };
    req.excelCol = this.getExcelCol(gridOpts);
    gridOpts.api.forEachNode(function (node, idx) {
      req.dataList.push(node.data);
    });
    axios
      .post(downUrl, req, { responseType: "arraybuffer" })
      .then((res) => {
        this.getExcelFile(res, fileName);
      })
      .catch((err) => {
        console.log(err);
      });
  }, */
  excelUploadFormatDown(param, gridOpts, downUrl, parEl, fileName) {
    var req = {
      input: param,
      excelCol: null,
    };
    req.excelCol = this.getExcelColAll(gridOpts);
    console.log(req);
    axios
      .post(downUrl, req, { responseType: "arraybuffer" })
      .then((res) => {
        this.getExcelFile(res, fileName);
      })
      .catch((err) => {
        console.log(err);
      });
  },
  async excelUpload(target, param) {
    var uploadYn = false;
    var msg = "";
    var fileNm = target.files[0].name;
    if (fileNm.includes(".xls") || fileNm.includes(".xlsx")) {
      let formData = new FormData();
      formData.append("files[0]", target.files[0]);
      formData.append("func", param.funcNm);
      formData.append("userId", param.userId);
      formData.append("userNm", param.userNm);
      formData.append("required", param.required);
      formData.append("excepted", param.excepted);
      await axios
        .post("/excelUpload", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          if (res.data.Output.resultMessage === "SUCCESS") {
            uploadYn = true;
            console.log("file Upload 완료");
          } else {
            var errMsg = res.data.Output.resultMessage;
            if (errMsg.includes("need to rewrite or cast the expression.")) {
              msg =
                "형식에 맞지 않는 데이터가 포함되어 있습니다. 확인 후 업로드 해주시기 바랍니다.";
            } else if (errMsg.includes("Required Column cannot be null")) {
              msg =
                "필수 입력 값이 누락되었습니다. 확인 후 업로드 해주시기 바랍니다.";
            }
            console.log(res.data.Output.resultMessage);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      msg =
        "다른 형식의 파일입니다. 엑셀 형태의 파일을 업로드 해주시기 바랍니다.";
    }
    var result = {
      sucYn: uploadYn,
      failMsg: msg,
    };
    return result;
  },
  isDynamicSensor(deviceType) {
    const dynamicSensors = ["1", "5", "6", "10"];
    if (dynamicSensors.includes(deviceType)) {
      return true;
    } else {
      return false;
    }
  },
  isStaticSensor(deviceType) {
    const staticSensors = ["2", "4", "60"];
    if (staticSensors.includes(deviceType)) {
      return true;
    } else {
      return false;
    }
  },
  isScube: (deviceType) => {
    return deviceType === "1" ? true : false;
  },
  isBGW(deviceType) {
    return deviceType === "2" ? true : false;
  },
  isSolar(deviceType) {
    return deviceType === "3" ? true : false;
  },
  isLGW(deviceType) {
    return deviceType === "4" ? true : false;
  },
  isGNSS(deviceType) {
    return deviceType === "5" ? true : false;
  },
  isKalman(deviceType) {
    return deviceType === "6" ? true : false;
  },
  isSyncGw(deviceType) {
    return deviceType === "7" ? true : false;
  },
  isWarningLight(deviceType) {
    return deviceType === "8" ? true : false;
  },
  isCAM(deviceType) {
    return deviceType === "9" ? true : false;
  },
  isCCD(deviceType) {
    return deviceType === "10" ? true : false;
  },
  isAMTM(deviceType) {
    return deviceType === "50" ? true : false;
  },
  isElBeam(deviceType) {
    return deviceType === "51" ? true : false;
  },
  isOptiFBG(deviceType) {
    return deviceType === "60" ? true : false;
  },
  is3axis: (deviceModel) => {
    const threeAxisModels = [
      "SSC-320(3.0g)",
      "SSC-320HR(2.0g)",
      "SSC-320HR(5.0g)",
    ];
    const matchModel = threeAxisModels.includes(deviceModel);
    if (matchModel) {
      return true;
    } else {
      return false;
    }
  },
  isTotalStation(deviceType) {
    return deviceType === "151" ? true : false;
  },
  isCableTensionSensor(sensorModelName) {
    const cableTensionSensors = ["SSC-500(2.0g)(장력)"];
    if (cableTensionSensors.includes(sensorModelName)) {
      return true;
    } else {
      return false;
    }
  },
  getChartRangeValues(chartRangeList, chartRange, param) {
    const getRangeValues = (range, keys) =>
      keys.map((key) =>
        range && range[key] !== undefined ? range[key] : null
      );

    const yAxisRange =
      chartRangeList.find((item) => item.sensorIdx === param.sensorIdx) ||
      chartRange.find((item) => item.stid === param.stid) ||
      {};

    const [dtick, dtick2] = getRangeValues(yAxisRange, [
      "yAxisInterval",
      "yAxisInterval2",
    ]);
    const [yAxisMin, yAxisMax] = getRangeValues(yAxisRange, [
      "yAxisRangeMin",
      "yAxisRangeMax",
    ]);
    const [yAxisMin2, yAxisMax2] = getRangeValues(yAxisRange, [
      "yAxisRangeMin2",
      "yAxisRangeMax2",
    ]);

    return { dtick, dtick2, yAxisMin, yAxisMax, yAxisMin2, yAxisMax2 };
  },
};



// WEBPACK FOOTER //
// ./src/components/common/utils.js